module.exports = __webpack_public_path__ + "img/onboarding-icon-warning.416f25c1.svg";